import { Resource } from "i18next";
import t from "../../locales/tlh.json";

export default t as Resource;
